<template>
  <svg :class="{ active }" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <template v-if="type === 'equal'">
      <line x1="5.75" y1="6.75" x2="12.25" y2="6.75" stroke="#55597A" stroke-width="1.5" stroke-linecap="round" />
      <line x1="5.75" y1="11.75" x2="12.25" y2="11.75" stroke="#55597A" stroke-width="1.5" stroke-linecap="round" />
    </template>

    <path
      v-else
      :class="{ 'rotate-180': type.includes('smaller') }"
      d="M6.96742 11.91L9.87742 8.99999L6.96742 6.08999C6.67492 5.79749 6.67492 5.32499 6.96742 5.03249C7.25992 4.73999 7.73242 4.73999 8.02492 5.03249L11.4674 8.47499C11.7599 8.76749 11.7599 9.23999 11.4674 9.53249L8.02492 12.975C7.73242 13.2675 7.25992 13.2675 6.96742 12.975C6.68242 12.6825 6.67492 12.2025 6.96742 11.91Z"
    />
    <line
      v-if="type.includes('-')"
      x1="6.75"
      y1="16.25"
      x2="11.25"
      y2="16.25"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: Boolean,
    type: {
      type: String,
      validator: val => ['equal-greater', 'equal-smaller', 'equal'].includes(val),
      default: 'equal-greater'
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  path {
    fill: var(--r-grey-3);

    &.rotate-180 {
      transform-origin: center;
    }
  }

  line {
    stroke: var(--r-grey-3);
  }

  &.active {
    path {
      fill: var(--r-secondary-1);
    }

    line {
      stroke: var(--r-secondary-1);
    }
  }
}
</style>
